import React from 'react'
import '../App.css'

function Separator() {
  return (
    <div className="separator"></div>
  )
}

export default Separator